<template>
  <div class="custom-date-picker">
    <custom-date-picker-menu-item
      :defaultDate="defaultStartDate"
      defaultLabel="Start Date. . ."
      @dateChanged="startDateChanged($event)"
    ></custom-date-picker-menu-item>
    <custom-date-picker-menu-item
      :defaultDate="defaultEndDate"
      v-if="showDateRange"
      defaultLabel="End Date. . ."
      @dateChanged="endDateChanged($event)"
    ></custom-date-picker-menu-item>
  </div>
</template>

<script>
import CustomDatePickerMenuItem from "./CustomDatePickerMenuItem";

export default {
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(),
    };
  },
  methods: {
    startDateChanged(evtDate) {
      this.$emit("startDateChanged", evtDate);
    },
    endDateChanged(evtDate) {
      this.$emit("endDateChanged", evtDate);
    },
  },
  props: {
    showDateRange: {
      type: Boolean,
      default: false,
    },
    defaultStartDate: {
      type: [Date, String],
    },
    defaultEndDate: {
      type: [Date, String],
    },
  },
  components: {
    CustomDatePickerMenuItem,
  },
};
</script>

<style lang="scss">
.custom-date-picker {
  .v-input__slot {
    border-bottom: 1px solid white !important;
  }

  & * {
    color: white !important;
    font-weight: bolder;
  }
}
</style>
